import {
    PURCHASE_LIST_REQUEST,
    PURCHASE_LIST_SUCCESS,
    PURCHASE_LIST_FAIL,
    PURCHASE_POST_REQUEST,
    PURCHASE_POST_SUCCESS,
    PURCHASE_POST_FAIL,
    PURCHASE_UPDATE_REQUEST,
    PURCHASE_UPDATE_SUCCESS,
    PURCHASE_UPDATE_FAIL,
    ITEM_GET_REQUEST,
    ITEM_GET_SUCCESS,
    ITEM_GET_FAIL,
    ITEM_UPDATE_REQUEST,
    ITEM_UPDATE_SUCCESS,
    ITEM_UPDATE_FAIL,
    TOKEN_CREATE_REQUEST,
    TOKEN_CREATE_SUCCESS,
    TOKEN_CREATE_FAIL,
    TOKEN_AUTHORIZATION_REQUEST,
    TOKEN_AUTHORIZATION_SUCCESS,
    TOKEN_AUTHORIZATION_FAIL
} from '../constants/purchaseConstants'

//purchaseをlistで取得するためのreducer
export const purchaseListReducer = (purchase = [], action) => {
    switch(action.type) {
        case PURCHASE_LIST_REQUEST:
            return {loading: true, purchase: []}
        case PURCHASE_LIST_SUCCESS:
            return {loading: false, purchase: action.payload}
        case PURCHASE_LIST_FAIL:
            return {loading: false, error: action.payload}
        default:
            return purchase
    }
}

//purchaseの登録と更新を行った際のreducer
export const purchasePostReducer = (purchase='', action) => {
    switch(action.type){
        case PURCHASE_POST_REQUEST:
            return {loading: true, purchase:''}
        case PURCHASE_POST_SUCCESS:
            return {loading: false, purchase: action.payload}
        case PURCHASE_POST_FAIL:
            return {loading: false, error: action.payload}
        case PURCHASE_UPDATE_REQUEST:
            return {loading: true, purcahse:''}
        case PURCHASE_UPDATE_SUCCESS:
            return {loading: false, purchase:action.payload}
        case PURCHASE_UPDATE_FAIL:
            return {loading: false, purchase: action.payload}
        default:
            return purchase
    }
}

//itemの取得を行った際のreducer
export const purchaseItemsGetReducer = (item='', action) => {
    switch(action.type){
        case ITEM_GET_REQUEST:
            return {loading: true, item:''}
        case ITEM_GET_SUCCESS:
            return {loading: false, item: action.payload}
        case ITEM_GET_FAIL:
            return {loading: false, error: action.payload}
        case ITEM_UPDATE_REQUEST:
            return {loading: true, item:''}
        case ITEM_UPDATE_SUCCESS:
            return {loading: false, item: action.payload}
        case ITEM_UPDATE_FAIL:
            return {loadin: false, error: action.payload}
        default:
            return item
    }
}

//OneTimeCode発行
export const oneTimeCodeReducer = (token='', action) => {
    switch(action.type){
        case TOKEN_CREATE_REQUEST:
            return {token_loading: true, token:''}
        case TOKEN_CREATE_SUCCESS:
            return {token_loading: false, token: action.payload}
        case TOKEN_CREATE_FAIL:
            return {token_loading: false, token_error: action.payload}
        case TOKEN_AUTHORIZATION_REQUEST:
            return {token_loading: true, token: ''}
        case TOKEN_AUTHORIZATION_SUCCESS:
            return {token_loading: false, token: action.payload}
        case TOKEN_AUTHORIZATION_FAIL:
            return {token_loading: false, token_error: action.payload}
        default:
            return token
    }
}